import { Types } from "common/createjs";
import { load } from "common/loader";
import { delay } from "common/promises";
import { onVideoTime } from "common/video";
import { Scene } from "fifth-animation/scene/main";
import { resourcePaths, toPath } from "fifth-animation/scene/resources";
import { fileName as soundFileName, loadSound, } from "fifth-animation/scene/sound";
import log from "loglevel";
import { Param } from "../common";
export async function start({ context, input, }) {
    let audioSrc = "";
    await load({
        onAudio: (src) => (audioSrc = src),
        filePaths: [
            ...resourcePaths,
            { src: toPath(soundFileName), type: Types.SOUND },
        ],
    });
    const sound = await loadSound(audioSrc);
    const { videoElem, progressElem } = await input.waiter.wait();
    $(videoElem).hide();
    progressElem.fadeOutAndHide();
    context.interactionVideoLoader.clearMovie("5번 영상.mp4");
    context.interactionVideoLoader.runWhenLoaded("6번 영상.mp4", async (elem) => {
        log.info("fifthvideo loaded elem is ", elem);
        videoElem.setAttribute("src", elem.src);
        videoElem.load();
    });
    const scene = new Scene();
    const sceneContext = await scene.start({
        sound,
        parentSelector: "#all-container",
    });
    await context.interactionVideoLoader.wait("6번 영상.mp4");
    $(videoElem).show();
    $(progressElem).show();
    await videoElem.play();
    progressElem.run({ index: 5, video: videoElem });
    // 화면이 깜빡이지 않도록 딜레이를 살짝 준다.
    await delay(100);
    sceneContext.app.view.remove();
    sceneContext.app.destroy(true);
    PIXI.utils.destroyTextureCache();
    const ret = new Param();
    onVideoTime({
        videoElement: videoElem,
        timeMillis: (videoElem.duration - 1) * 1000,
        callback: () => {
            progressElem.fadeOutAndHide();
        },
    });
    $(videoElem).one("ended", () => {
        ret.fill({ videoElem, progressElem });
    });
    return ret;
}
export async function skippedStart({ context, input, waitVideo, }) {
    const { videoElem, progressElem } = await input.waiter.wait();
    $(videoElem).hide();
    progressElem.fadeOutAndHide();
    context.interactionVideoLoader.runWhenLoaded("6번 영상.mp4", async (elem) => {
        videoElem.setAttribute("src", elem.src);
        videoElem.load();
    });
    await context.interactionVideoLoader.wait("6번 영상.mp4");
    $(videoElem).show();
    $(progressElem).show();
    await videoElem.play();
    progressElem.run({ index: 5, video: videoElem });
    const ret = new Param();
    if (waitVideo) {
        await delay(1000);
        videoElem.currentTime = videoElem.duration - 4;
        onVideoTime({
            videoElement: videoElem,
            timeMillis: (videoElem.duration - 1) * 1000,
            callback: () => {
                progressElem.fadeOutAndHide();
            },
        });
        $(videoElem).one("ended", () => {
            ret.fill({ videoElem, progressElem });
        });
    }
    else {
        ret.fill({ videoElem, progressElem });
    }
    return ret;
}
//# sourceMappingURL=main.js.map